import axios from "axios";
import { useEffect, useState } from "react"
import moment from 'moment';
import "moment/locale/es";
import { useIsMount } from './useIsMount';
import { useLocation } from "react-router-dom";
import { errorHandler } from "../utils/errorHandler";

const PAGE_SIZE = 12;
const MONTHS_DICT = {
    'enero': 0,
    'febrero': 1,
    'marzo': 2,
    'abril': 3,
    'mayo': 4,
    'junio': 5,
    'julio': 6,
    'agosto': 7,
    'septiembre': 8,
    'octubre': 9,
    'noviembre': 10,
    'diciembre': 11
};

function useQuery() {
    return new URLSearchParams(useLocation().search)
}

export default function useGrandCourses() {
    const [specialtyFilter, setSpecialtyFilter] = useState(null);
    const [academicUnitFilter, setAcademicUnitFilter] = useState(null);
    const [monthFilter, setMonthFilter] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null)
    const [allCourses, setAllCourses] = useState([]);
    const [activePage, setPage] = useState(1);
    const isMount = useIsMount();
    const location = useLocation();

    const filterCourses = (_courses) => {
        if (!_courses) return
        //APPLY FILTERS
        let filteredCourses = _courses;
        if (specialtyFilter) {
            filteredCourses = filteredCourses.filter((course) => course?.specialties?.toUpperCase() === specialtyFilter);
        }
        if (academicUnitFilter) {
            filteredCourses = filteredCourses.filter((course) => course.type.toUpperCase() === academicUnitFilter);
        }
        if (monthFilter) {
            filteredCourses = filteredCourses.filter((course) => {
                return moment(course.startDate).locale("es").format("MMMM").toUpperCase() === monthFilter;
            });
        }
        return filteredCourses;
    }

    const paginatedCourses = (_filteredCourses, _page, _pageSize) => {
        if (!_filteredCourses) return
        //APPLY PAGINATION
        const startIndex = (_page - 1) * _pageSize;
        const endIndex = startIndex + _pageSize;

        return _filteredCourses.slice(startIndex, endIndex);
    };

    const query = useQuery()
    const searchQuery = query.get('query') || ''

    useEffect(() => {
        if (isMount) {
            setIsLoading(true);
            const url = `${process.env.REACT_APP_BACKEND_SERVER}/info/academicUnitsByDivision?division=large`;
            axios
                .get(url)
                .then((res) => {
                    if (searchQuery) {
                        const filteredOpen = res.data.open.filter((item) => {
                            if (item.comercialInformation.outsideCampus) return null;
                            const name = item.comercialInformation.name.toLowerCase()
                            const type = item.type.toLowerCase()
                            const specialty = item.specialties.toLowerCase()

                            return (
                                name.includes(searchQuery) ||
                                type.includes(searchQuery) ||
                                specialty.includes(searchQuery)
                            )
                        })
                            .map(item => {
                                const dateParts = item.comercialInformation.initialDate.split(" ")
                                const datePartsLower = dateParts.map(el => el.toLowerCase());
                                if (datePartsLower.includes("de")) {
                                    datePartsLower.splice(datePartsLower.indexOf("de"), 1);
                                }

                                const month = MONTHS_DICT[datePartsLower[1].toLowerCase()];
                                const date = moment({
                                    day: datePartsLower[0],
                                    month: month,
                                    year: datePartsLower[2]
                                });
                                return {
                                    ...item,
                                    startDate: date
                                }
                            })
                        const filteredClosed = res.data.close.filter((item) => {
                            if (item.comercialInformation.outsideCampus) return null;
                            const name = item.comercialInformation.name.toLowerCase()
                            const type = item.type.toLowerCase()
                            const specialty = item.specialties.toLowerCase()

                            return (
                                name.includes(searchQuery) ||
                                type.includes(searchQuery) ||
                                specialty.includes(searchQuery)
                            )
                        })
                            .map(item => {
                                const dateParts = item.comercialInformation.initialDate.split(" ")
                                const datePartsLower = dateParts.map(el => el.toLowerCase());
                                if (datePartsLower.includes("de")) {
                                    datePartsLower.splice(datePartsLower.indexOf("de"), 1);
                                }

                                const month = MONTHS_DICT[datePartsLower[1].toLowerCase()];
                                const date = moment({
                                    day: datePartsLower[0],
                                    month: month,
                                    year: datePartsLower[2]
                                });
                                return {
                                    ...item,
                                    startDate: date
                                }
                            })
                        return setAllCourses({
                            open: filteredOpen,
                            close: filteredClosed,
                        })
                    }
                    // Sort courses by date
                    const openedCourses = res.data.open.map((_oCourse) => {
                        // Filter courses outsideCampus (openSource webinars)
                        if (_oCourse.comercialInformation.outsideCampus) return null;
                        const dateParts = _oCourse.comercialInformation.initialDate.split(" ")
                        const datePartsLower = dateParts.map(el => el.toLowerCase());
                        if (datePartsLower.includes("de")) {
                            datePartsLower.splice(datePartsLower.indexOf("de"), 1);
                        }

                        const month = MONTHS_DICT[datePartsLower[1].toLowerCase()];
                        const date = moment({
                            day: datePartsLower[0],
                            month: month,
                            year: datePartsLower[2]
                        });

                        return {
                            ..._oCourse,
                            startDate: date
                        }
                    }).filter(el => el !== null)
                    openedCourses.sort((a, b) => b.startDate - a.startDate);
                    const closedCourses = res.data.close.map((_cCourse) => {
                        // Filter courses outsideCampus (openSource webinars)
                        if (_cCourse.comercialInformation.outsideCampus) return null;
                        const dateParts = _cCourse.comercialInformation.initialDate.split(" ")
                        const datePartsLower = dateParts.map(el => el.toLowerCase());
                        if (datePartsLower.includes("de")) {
                            datePartsLower.splice(datePartsLower.indexOf("de"), 1);
                        }

                        const month = MONTHS_DICT[datePartsLower[1].toLowerCase()];
                        const date = moment({
                            day: datePartsLower[0],
                            month: month,
                            year: datePartsLower[2]
                        });

                        return {
                            ..._cCourse,
                            startDate: date
                        }
                    }).filter(el => el !== null)
                    closedCourses.sort((a, b) => b.startDate - a.startDate);

                    // Calculate upcoming courses
                    const currentDate = moment();
                    const upcomingCourses = openedCourses
                        .filter(course => course.startDate.isAfter(currentDate))
                        .sort((a, b) => a.startDate - b.startDate)
                        .slice(0, 3)


                    setAllCourses({
                        open: openedCourses,
                        close: closedCourses,
                        upcomingCourses
                    });
                })
                .catch((err) => {
                    console.log(err)
                    const errorMessage = errorHandler(err)
                    setError(errorMessage)
                })
                .finally(() => setIsLoading(false));
        }
    }, [isMount, searchQuery]);

    useEffect(() => {
        const specialty = query.get("especialidad");
        const academicUnit = query.get("tipo");
        const month = query.get("mes");


        if (specialty) setSpecialtyFilter(specialty.toUpperCase());
        if (academicUnit) setAcademicUnitFilter(academicUnit.toUpperCase());
        if (month) setMonthFilter(month.toUpperCase());
    }, [location.search, query]);

    return {
        setSpecialtyFilter, setAcademicUnitFilter, setMonthFilter, error, isLoading, allCourses, paginatedCourses, filterCourses,activePage, monthFilter, academicUnitFilter, specialtyFilter, setPage, 
PAGE_SIZE
    }
}